import { z } from 'zod';
export const taskBlockTypesSchema = z.union([
    z.literal('element:heading'),
    z.literal('element:instructions'),
    z.literal('element:separator'),
    z.literal('element:image'),
    z.literal('element:video'),
    z.literal('element:file'),
    z.literal('field:text'),
    z.literal('field:email'),
    z.literal('field:phone'),
    z.literal('field:url'),
    z.literal('field:number'),
    z.literal('field:currency'),
    z.literal('field:checkbox-list'),
    z.literal('field:radio-list'),
    z.literal('field:dropdown-single'),
    z.literal('field:dropdown-many'),
    z.literal('field:toggle'),
    z.literal('field:date'),
    z.literal('field:time'),
    z.literal('field:date-time'),
    z.literal('field:date-range'),
    z.literal('field:file'),
    z.literal('field:image'),
]);
export const optionSchema = z.array(z.object({
    key: z.string(),
    label: z.string().nullable(),
    subLabel: z.string().optional(),
    disabled: z.boolean().optional(),
}));
export const taskBlockOptionsSchema = z.object({
    'element:heading:label': z.string().optional(),
    'element:instructions:value': z.string().optional(),
    'element:separator:weight': z.enum(['thin', 'thick']).optional(),
    // element:image options
    'element:image:align': z.enum(['left', 'center', 'right']).optional(),
    'element:image:scale': z.enum(['full', '75', '50', '25']).optional(),
    'element:image:caption': z.string().optional(),
    'element:image:alt-text': z.string().optional(),
    'element:image:external-link': z.string().optional(),
    // shared across all field types
    'field:shared:label': z.string().optional(),
    'field:shared:description': z.string().optional(),
    'validator:shared:required': z.boolean().optional(),
    // text options
    'field:text:placeholder': z.string().optional(),
    'field:text:default-value': z.string().optional(),
    'field:text:number-of-lines': z.number().optional(),
    'validator:text:min-length': z.number().optional(),
    'validator:text:max-length': z.number().optional(),
    // email options
    'validator:is-email': z.boolean().optional(),
    'validator:is-url': z.boolean().optional(),
    // choice options
    // { key: string; label: string; subLabel?: string | undefined; disabled?: boolean | undefined; }
    'field:choice:options': optionSchema.optional(),
    'field:choice:show-other-option': z.boolean().optional(),
    // toggle options
    'field:toggle:default-value': z.boolean().optional(),
    // upload options
    'field:upload:instructions': z.string().optional(),
    'field:upload:file-types-groups': z
        .array(z.enum([
        'images',
        'rasterImages',
        'vectorImages',
        'audio',
        'videos',
        'fonts',
        'archives',
        'documents',
        'workingFiles',
    ]))
        .optional(),
    'field:upload:file-count-limit': z.number().optional(),
});
export const taskSectionInput = z.array(z.object({
    clientKey: z.string(),
    title: z.string().optional().nullable(),
    sort: z.number(),
    blocks: z.array(z.object({
        clientKey: z.string(),
        sort: z.number(),
        type: taskBlockTypesSchema,
        options: taskBlockOptionsSchema,
        sourceBlockId: z.string().optional(),
    })),
}));
//# sourceMappingURL=task.js.map